import React from "react";
import { Col, Form, Row } from "react-bootstrap";

export default function EmailDropdown() {
  return (
    <div>
      {" "}
      <div className="align-items-center rounded-3 p-4 bg-purple-gradient-darker-reverse">
        <div className="ms-2">
          <span className="fs-4 fw-bold "> EMAIL</span>
        </div>
        <div className="text-secondary ms-2">
          Send and receive monitoring information securely through your
          designated email accounts. <br />
          Specify domain authentication details here
        </div>
        <div className="ms-3 my-3">
          <div>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="domainAuthentication"
            >
              <Form.Label className="fw-bold">
                Domain authentication:
              </Form.Label>
              <Col sm="10" className="p-2">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
          </div>
          <div>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="specificEmailAddress"
            >
              <Form.Label className="fw-bold">
                Specific email address:
              </Form.Label>
              <Col sm="10">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
          </div>
          <div>
            <Form.Group as={Row} className="mb-3" controlId="iPWhitelisting">
              <Form.Label className="fw-bold">
                IP whitelisting (single IPs or an IP range):
              </Form.Label>
              <Col sm="10">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
          </div>
        </div>
      </div>
    </div>
  );
}
